import React from 'react'
import HeroSection from '../../component/HeroSection/HeroSection' 

import Mainbody from '../../component/Mainbody/Mainbody'

const Homepage = () => {
    return (
        <div>
            <HeroSection />
            <Mainbody />
            
        </div>
    )
}

export default Homepage
